import React from "react";
import { useTranslation } from "react-i18next";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider,
  Button,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import ProductFilters from "./ProductFilters";

/**
 * Mobile Filter Drawer component
 * Displays product filters in a mobile drawer
 *
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the drawer is open
 * @param {Function} props.onClose - Function to close the drawer
 * @param {Object} props.filterProps - Props to pass to ProductFilters component
 * @returns {JSX.Element} The MobileFilterDrawer component
 */
const MobileFilterDrawer = ({ open, onClose, filterProps }) => {
  const { t } = useTranslation("common");
  const { t: tProducts } = useTranslation("products");

  // Ensure we have valid filter props
  const safeFilterProps = filterProps || {};

  const handleApplyFilters = () => {
    console.log("Applying filters from mobile drawer");
    onClose();
  };

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: "85%", maxWidth: "350px", p: 2 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">
          {tProducts("catalog.filters.title")}
        </Typography>
        <IconButton onClick={onClose} edge="end">
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Box sx={{ overflow: "auto", flexGrow: 1 }}>
        <ProductFilters {...safeFilterProps} />
      </Box>

      <Divider sx={{ my: 2 }} />

      <Button variant="contained" fullWidth onClick={handleApplyFilters}>
        {tProducts("catalog.filters.apply")}
      </Button>
    </Drawer>
  );
};

export default MobileFilterDrawer;
